<app-video-player (durationVideoTime) = "durationVideoTime($event)"  [first_video]='first_video' [second_video]='second_video' *ngIf="isSlowMotionGraphicsLoading" [event_id]='eventId'></app-video-player>
<app-spotlight-full-page-loader *ngIf="isLoading" [page]='page'></app-spotlight-full-page-loader>
<div *ngIf="!isSlowMotionGraphicsLoading && !isLoading" class="theater-page">
    <div class="group-share-container" *ngIf="!hideGroupSharing">
        <!-- <app-group-share (isGroupShareActive)="isGroupShareActive($event)" [eventId]="eventId"></app-group-share> -->

    </div>

    <div class="theater-background">
        <div class="background-image-div" >
            <img *ngIf="!isGroupSharingActive" class="background-image" fxHide fxShow.gt-sm fxShow.handset.landscape [src]="event.eventImage"
                alt="event-image" width="100%" height="100%">
            <img class="background-image" fxHide fxShow.handset.portrait fxShow.tablet.portrait
                [src]="event.mobilethumbimage" alt="event-image" width="100%" height="100%">
        </div>
        <div class="theater-front">
            <div class="theater-heading">
                <span>cinejoy</span>
            </div>
            <div class="theater-notification" [ngClass]="{'invisible': !showNotification}">
                <app-notification-badge [notifyType]="notifyType" [message1]="message1" [message2]="message2"
                    (notificationClick)=notificationClick() *ngIf="showNotification"></app-notification-badge>
            </div>
            <div class="feature-guests">
                <div class="opening-remarks-guest" *ngIf="showOpeningRemarksGuests">
                    <div class="thumbnail-div">
                        <img class="guest-thumbnail" src="{{featureGuests[0].img}}">
                    </div>
                    <div class="thumbnail-div" style="width: 10%;"></div>
                    <div class="thumbnail-div">
                        <img class="guest-thumbnail" src="{{featureGuests[1].img}}">
                    </div>
                </div>
                <div class="qna-guests" *ngIf="showQnasGuests">
                    <div *ngFor="let guest of featureGuests" style="display: inline-block;">
                        <div class="thumbnail-div" style="margin-right:20px">
                            <img class="guest-thumbnail-qna" src="{{guest.img}}">
                        </div>
                    </div>
                </div>
                <div class="watch-video-button" *ngIf="showOpeningRemarksGuests">
                    <button [disabled]="timeDiff > 0" (click)="showOpeningRemarkVideo()"  type="button" class="btn btn-light">
                        WATCH OPENING REMARKS
                    </button>
                </div>
                <div class="watch-video-button" *ngIf="showQnasGuests">
                    <button [disabled]="timeDiff > 0" (click)="showQnaVideo()"  type="button" class="btn btn-light">
                        WATCH Q & A session
                    </button>
                </div>
            </div>
            <div class="group-sharing-lobby" *ngIf="activateLobby && canUserAccessMovie">
                <button  (click)="redirectToLobby()"  type="button" class="btn btn-light">
                    Enter Group Sharing Lobby
                </button>
            </div>
            <div class="theater-arena">
                <div class="opening-remarks" fxLayout="row" fxLayoutAlign="center center" *ngIf="showOpeningRemarksVideo">
                    <div class="justify-content-center"
                    fxFlex=95 fxFlex.handset.landscape=65 fxFlex.gt-sm=57 fxFlex.gt-md=58
                    fxLayout="column" fxLayoutAlign="center center" *ngIf="showOpeningRemarksVideo">
                        <iframe fxFill fxFlex=100 [src]="openingRemarksVimeoStreamLink"
                        frameborder="0" mozallowfullscreen webkitallowfullscreen allowfullscreen scrolling="no">
                    </iframe>
                    </div>
                </div>
                <div class="qna" fxLayout="row" fxLayoutAlign="center center" *ngIf="showQnasVideo">
                    <div class="justify-content-center"
                    fxFlex=95 fxFlex.handset.landscape=65 fxFlex.gt-sm=57 fxFlex.gt-md=58
                    fxLayout="column" fxLayoutAlign="center center" *ngIf="showQnasVideo">
                        <iframe fxFill fxFlex=100 [src]="qnaVimeoStreamLink"
                        frameborder="0" mozallowfullscreen webkitallowfullscreen allowfullscreen scrolling="no">
                        </iframe>
                    </div>
                </div>
                <div class="theater" fxLayout="row" fxLayoutAlign="center center" *ngIf="showTheatersVideo">
                    <div class="justify-content-center"
                    fxFlex=95 fxFlex.handset.landscape=65 fxFlex.gt-sm=57 fxFlex.gt-md=58
                    fxLayout="column" fxLayoutAlign="center center">
                        <p class="mobile_view" *ngIf="!canUserAccessMovie && (message != '' && message != undefined && message != null)" style="color: white;position: absolute; width: 100%;
                        font-family: 'Poppins Regular';font-size: 18px;">{{message}} <a (click)="redirectUserBuyTicket()"> Click here </a> to purchase the movie.</p>
                        <iframe fxFill fxFlex=100 *ngIf="canUserAccessMovie" class="movie-iframe" [src]="streamLink"
                            frameborder="0" mozallowfullscreen webkitallowfullscreen allowfullscreen scrolling="no">
                        </iframe>
                        <!-- <iframe src="https://player.vimeo.com/video/76979871?app_id=122963" width={{frame_width}} height={{frame_height}} style="border-radius: 5px;"frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="audience" fxLayout="column">
            <div class="audience-image-div">
                <img src="assets/images/cinejoy/Crowd.png" alt="audience" class="audience-image">
            </div>

            <div class="theater-cards">
                <div fxLayout.lt-sm="column" fxLayout.handset.landscape="row" fxLayout.gt-xs="row"
                fxFlexAlign.lt-sm="end" fxFlexAlign.gt-xs="end" style="width: 98vw;"
                fxLayoutGap.lt-sm="15px" fxLayoutGap.gt-xs="0px">
                    <div class="new-chat-card"
                    fxFlexOrder.lt-sm=1 fxFlexOrder.handset.landscape=3 fxFlexOrder.gt-xs=3
                    fxFlex.lt-sm=40 fxFlex.gt-xs=40 fxFlex.gt-md=16 fxFlex.lg=20>
                        <app-red-carpet-chatbar [eventId]="eventId" [userId]="userId" [page]="page"></app-red-carpet-chatbar>
                    </div>
                    <div fxHide.lt-sm fxShow.handset.landscape fxShow.gt-xs
                    fxFlex.handset.landscape fxFlex.gt-xs
                    fxFlexOrder.lt-sm=3 fxFlexOrder.handset.landscape=2 fxFlexOrder.gt-xs=2>
                    </div>
                    <div class="new-emoji-card"
                    fxFlexOrder.lt-sm=2 fxFlexOrder.handset.landscape=1 fxFlexOrder.gt-xs=1
                    fxFlex.lt-sm=40 fxFlex.gt-xs=36 fxFlex.gt-md=16 fxFlex.lg=28
                    ngClass.gt-xs="new-emoji-card-div">
                        <app-emoji-chart [id]="eventId" [page]="page"></app-emoji-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>